import WarningIcon from '@mui/icons-material/Warning';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { ErrorMessage } from 'formik';

export const FieldErrorMessage = ({ name }: { name: string }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        '& svg': {
          alignSelf: 'flex-start'
        }
      }}
    >
      <WarningIcon
        sx={{
          color: theme.palette.error.main,
          marginRight: theme.spacing(0.5),
          marginTop: theme.spacing(-0.2),
          width: '0.65em'
        }}
      />
      <ErrorMessage name={name} />
    </Box>
  );
};
